import { NgModule } from '@angular/core';

import { WindowService } from '@app/shared/services/window.service';

import { OpinConsentService } from '../modules/consents/services/opin-consent/opin-consent.service';
import { TransmitterService } from '../modules/consents/services/transmitter/transmitter.service';
import { OpenInsuranceService } from '../open-insurance.service';

import atomModules from './components/atoms';
import moleculesModules from './components/molecules';
import organismsModules from './components/organisms';

const COMPONENTS = [atomModules, moleculesModules, organismsModules];

@NgModule({
  providers: [
    WindowService,
    TransmitterService,
    OpinConsentService,
    OpenInsuranceService
  ],
  exports: [COMPONENTS],
  imports: [COMPONENTS]
})
export class OpenInsuranceSharedModule {}
